<template>
  <header class="header">
    <div class="container-fluid position-relative">
      <div
        class="header-back"
        @click="back">
        <fa-icon icon="chevron-left" />
      </div>
      <div class="position-absolute">
      </div>
      <div class="header-title">{{ $route.meta.title }}<span v-if="customTitle.length > 0"> {{customTitle}}</span> </div>
      <template v-if="action === 'logout'">
        <div
          class="header-logout"
          @click="logout()">ออกจากระบบ</div>
      </template>
      <template v-if="action === 'search-news'">
        <div
          class="header-search-news"
          @click="searchNewsClickHandler">
          <fa-icon icon="search" />
        </div>
      </template>
      <!--      <template v-if="action === 'search-course'">-->
      <!--        <div class="header-search-course">-->
      <!--          <fa-icon icon="search" class="cursor-pointer" @click="searchCourseClickHandler"></fa-icon>-->
      <!--        </div>-->
      <!--      </template>-->
    </div>
  </header>
</template>

<script>
  export default {
    name: 'header',
    props: {
      action: {
        type: String,
        default: ''
      },
      customTitle: {
        type: String,
        default: ''
      },
      customID: {
        type: String,
        default: ''
      }
    },
    methods: {
      back () {
        if (this.$route.name === 'Learning') {
          this.$router.push('/')
        } else if (this.$route.name === 'Course') {
          this.$router.push('/learning')
        } else if (this.$route.name === 'Profile') {
          this.$router.push('/')
        } else if (this.$route.name === 'LectureVideo') {
          this.$router.push(`/course/${this.customID}/1`)
        } else if (this.$route.name === 'LearningQuiz') {
          this.$router.push(`/course/${this.customID}/2`)
        } else if (this.$route.name === 'Home') {
          if (confirm('ต้องการออกจากระบบ?')) {
            this.$router.back()
          }
        } else {
          this.$router.back()
        }
      },
      logout () {
        let message = 'คุณต้องการออกจากระบบใช้หรือไม่?'
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'ใช้',
          cancelText: 'ไม่',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
          verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
          verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        }
        var self = this
        this.$dialog.confirm(message, options)
          .then(function (dialog) {
            self.$router.push('/login?logout=1')
          })
          .catch(function () {
            console.log('Clicked on cancel')
          })
      },
      searchNewsClickHandler () {
        this.$router.push('/news/search')
      },
      searchCourseClickHandler () {
        this.$router.push('/course/search')
      }
    },
    created () {
      document.addEventListener('backbutton', this.back, false)
    },
    beforeDestroy () {
      document.removeEventListener('backbutton', this.back)
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  header.header {
    position: fixed;
    z-index: 1;
    top: 0;
    width: 100%;
    height: $header-height;
    line-height: $header-height;
    color: $text-color;
    background: white;
    border-bottom: 1px solid $border-color-dark;
    &.header-primary {
      color: white;
      background: linear-gradient(180deg, $primary-color 0%, $primary-color-dark 100%);
      border-bottom: none;
    }
    .header-back {
      @extend .position-absolute;
      @extend .cursor-pointer;

      height: 44px;
      width: 44px;
      cursor: pointer;
      display: flex;
      left: 0;
      & > * {
        margin: auto;
      }
    }
    .header-title {
      @extend .text-center;
      font-size: 18px;
      font-weight: 400;
    }
    .header-logout, .header-search-news, .header-search-course {
      @extend .position-absolute;
      @extend .cursor-pointer;

      height: 44px;
      width: 44px;
      cursor: pointer;
      display: flex;
      right: 0;
      top: 0;
      & > * {
        margin: auto;
      }
    }
    .header-logout {
      width: auto;
      padding: 0 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.component.vue